export const SCREEN_WIDTH = window.innerWidth;
export const SCREEN_HEIGHT = window.innerHeight;

export function sliceText(text, MAX_LENGTH) {
  if (!text || !text.length) return '...';
  return text.length > MAX_LENGTH
    ? text.slice(0, MAX_LENGTH - 1) + '...'
    : text;
}
